import axios from "axios";
import Authenticate from "./Authenticate";
import Message from "./Message";
import Loader from "./Loader";

let auth = new Authenticate();

export default class Request {
  createParams(className, actionName, params, noLogin) {
    let requestParams = {};
    if (noLogin) {
      requestParams.uid = auth.getNoLoginUid();
      console.log('noLogin')
      console.log(requestParams.uid)
    } else {
      requestParams.uid = auth.getUid();
    }
    requestParams.className = className;
    requestParams.actionName = actionName;

    params.forEach((val, index) => {
      requestParams["arg" + (index + 1)] = val;
    });

    return { post: JSON.stringify(requestParams) };
  }

  create() {
    let httpClient = axios.create({
      baseURL: process.env.VUE_APP_API_BASE_URL,
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      responseType: "json",
    });

    // 送信前のインターセプタ
    httpClient.interceptors.request.use((request) => {
      Loader.show();
      return request;
    });

    // ネットワークエラー時のインターセプト
    httpClient.interceptors.response.use(
      (res) => {
        Loader.hide();

        let result = JSON.parse(res.data.d);
        // ログインをしなおす必要がある
          if (result.status == "bad" && result.UseLogin) {
            Message.error().fire({
              title: result.msg,
            });
            auth.logout();
          } else if (result.status == "bad") {
            if (result.msg.indexOf("\t") > -1) {
              let messages = result.msg.split("\t");
              return {
                status: "bad",
                arg: messages[0],
                msg: messages[1]
              };
            } else {
              Message.error().fire({
                title: result.msg,
              });
              return Promise.reject(result);
            }
            // 正常系
          } else {
            return result;
          }
      },
      // ネットワーク異常系
      (err) => {
        Loader.hide();
        // 4xx,5xxはこっち
        Message.error().fire({
          title: "通信エラーが発生しました",
          text: err,
        });
        return Promise.reject(err);
      }
    );

    return httpClient;
  }
}
